import PropTypes from "prop-types";
import styles from "./ImageLink.css";

const ImageLink = ({ image, children, url, alt = "" }) => (
  <a href={url} className={styles.imageLink}>
    <span className={styles.text}>{children}</span>
    <img className={styles.image} src={image} alt={alt} />
  </a>
);

ImageLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  alt: PropTypes.string,
  basePath: PropTypes.string,
};

ImageLink.displayName = "ImageLink";

export default ImageLink;
